/* eslint-disable no-restricted-properties */
import { format, formatDistanceToNow, isValid, parseISO } from 'date-fns';

export const DATE_FORMAT_LONG = 'dd MMM yyyy HH:mm:ss';
export const DATE_FORMAT_SHORT = 'dd MMM yyyy HH:mm';
export const DATE_FORMAT_ONLY = 'dd MMM yyyy';
export const TIME_FORMAT = 'HH:mm';

export const toPickerDate = (value) => {
  if (value == null || value === '') return null;
  if (value instanceof Date) return isValid(value) ? value : null;
  if (typeof value === 'string') {
    const d = parseISO(value);
    if (isValid(d)) return d;
  }
  const d = new Date(value);
  return isValid(d) ? d : null;
};

const formatWith = (value, pattern, fallback) => {
  const d = toPickerDate(value);
  return d ? format(d, pattern) : fallback;
};

export const formatDateTime = (value, fallback = '—') =>
  formatWith(value, DATE_FORMAT_LONG, fallback);

export const formatDateTimeShort = (value, fallback = '—') =>
  formatWith(value, DATE_FORMAT_SHORT, fallback);

export const formatDate = (value, fallback = '—') =>
  formatWith(value, DATE_FORMAT_ONLY, fallback);

export const formatTime = (value, fallback = '—') =>
  formatWith(value, TIME_FORMAT, fallback);

export const formatRelative = (value, fallback = '—') => {
  const d = toPickerDate(value);
  if (!d) return fallback;
  try {
    return formatDistanceToNow(d, { addSuffix: true });
  } catch {
    return fallback;
  }
};

export const convertUTCDateToLocalDate = (date) => {
  const dateLocal = new Date(date);
  return new Date(dateLocal.getTime() - dateLocal.getTimezoneOffset() * 60 * 1000);
};

export default convertUTCDateToLocalDate;
